import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

window.document.title = '华西直播间';

return { __sfc: true, }
}

})